import script from "./_channel-messages.vue?vue&type=script&setup=true&lang=js"
export * from "./_channel-messages.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__